import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Subject = styled.div `
  color: ${Colors.GS1000};
`;
export const Body = styled.div `
  color: ${Colors.GS600};
`;
